export default "__VITE_ASSET__CKJgndpm__"